import Table from '@tiptap/extension-table';
import { columnResizing } from '@tiptap/pm/tables';

export const SummaryTable = Table.extend({
    addProseMirrorPlugins() {
        const plugins = this.parent?.() ?? [];
        if (!this.options.resizable || this.editor.isEditable) return plugins;

        // Tiptap skips resizing when the editor starts read-only (while drafts
        // load). Install it now so setEditable(true) also enables column dragging.
        // The native mouse handlers check view.editable before allowing a resize.
        return [
            columnResizing({
                handleWidth: this.options.handleWidth,
                cellMinWidth: this.options.cellMinWidth,
                defaultCellMinWidth: this.options.cellMinWidth,
                View: this.options.View,
                lastColumnResizable: this.options.lastColumnResizable,
            }),
            ...plugins,
        ];
    },
});
